<script setup>
import { onMounted, ref } from "vue";
import { notify } from "@kyvg/vue3-notification";
import ToastNotification from "@/components/ToastNotification.vue";

const toastIdentifer = ref("saved-profile");

onMounted(() => {
    const params = new URLSearchParams(window.location.search);
    const profileSaved = params.get("profile-saved");
    if (profileSaved === "true") {
        notify({
            id: toastIdentifer.value,
            title: "Success",
            text: "Changes saved.",
            duration: 3500,
            type: "success",
        });
        const profileUrl = window.location.href;
        const questionMarkIndex = profileUrl.indexOf("?");
        const urlNoParam = profileUrl.slice(0, questionMarkIndex);
        window.history.replaceState({}, "", urlNoParam);
    }
});

</script>

<template>
    <div>&nbsp;</div>
    <ToastNotification :identifer="toastIdentifer"/>
</template>
